// extracted by mini-css-extract-plugin
export default {"disableScroll":"scroll-locker_disableScroll__ifnL6"};